import actions from './actions';

const initialState = {
    value: 0
}

export default function noteDashboardReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_COUNT_ACTIVE_NOTE:
            return {
                ...state,
                value: action.data
            }
        default:
            return state
    }
}